import React, { ReactComponentElement } from 'react';
import { CardRounded, Tab, TabContent, TabContentGroup, TabGroup, TabMenu } from 'dls-react-filters';
import styles from 'src/components/admin/adminPage.module.scss';
import AdminEmailForm from 'src/components/admin/AdminEmailForm';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { AdminSetSyncStatusForm } from 'src/components/admin/AdminSetSyncStatusForm';
import { AdminUserForm } from 'src/components/admin/AdminUserForm';
import { useUser } from 'src/hooks/queries/users';
import { FullUserModel } from 'src/types/user.model';
import AdminUserInfo from 'src/components/admin/AdminUserInfo';
import Loading from 'src/components/atomic/atoms/loading/Loading';
import { AdminDeleteInstitutionForm } from 'src/components/admin/AdminDeleteInstitutionForm';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

export default function AdminPage(): ReactComponentElement<any> {
    const { data: user } = useUser() as { data: FullUserModel };
    return user == null ? (
        <Loading />
    ) : (
        <main className={styles.adminPage}>
            <CardRounded className={styles.card}>
                <Typography variant={TypographyVariants.HEADING_L} component="h1">
                    {LiteralsService.getLiteral('Admin.title')}
                </Typography>
                <AdminUserInfo user={user} />
                <TabGroup defaultSelectedTab="tab-1">
                    <TabMenu>
                        <Tab contentId="tab-panel-1" id="tab-1" data-cy={Selectors.Admin.USER_TAB}>
                            {LiteralsService.getLiteral('Admin.userTabTitle')}
                        </Tab>
                        <Tab contentId="tab-panel-2" id="tab-2" data-cy={Selectors.Admin.ACCOUNT_TAB}>
                            {LiteralsService.getLiteral('Admin.accountTabTitle')}
                        </Tab>
                        <Tab contentId="tab-panel-3" id="tab-3">
                            {LiteralsService.getLiteral('Admin.emailTabTitle')}
                        </Tab>
                    </TabMenu>
                    <TabContentGroup>
                        <TabContent id="tab-panel-1" key="tab-1" labelledBy="tab-1" className={styles.panel}>
                            <AdminUserForm user={user} />
                        </TabContent>
                        <TabContent id="tab-panel-2" key="tab-2" labelledBy="tab-2" className={styles.panel}>
                            <AdminSetSyncStatusForm />
                            <AdminDeleteInstitutionForm />
                        </TabContent>
                        <TabContent id="tab-panel-3" labelledBy="tab-3" className={styles.panel}>
                            <AdminEmailForm />
                        </TabContent>
                    </TabContentGroup>
                </TabGroup>
            </CardRounded>
        </main>
    );
}
